import {
  Container,
  Card,
  CardHeader,
  CardContent,
  MenuItem,
  Grid,
  Typography,
  Box
} from '@mui/material';
import TextField from '@mui/material/TextField';
import request from '../../utils/request';
import LoadingButton from '@mui/lab/LoadingButton';
import SnackbarAlert from '../common/SnackbarAlert';
import { useState, useEffect } from 'react';

import { useFormik } from 'formik';
import moment from 'moment';

function PolicyClaimSurveyorEdit({ policyClaimId, claimsView }) {
  const [policyData, setPolicyData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [loadingClaimTypes, setLoadingClaimTypes] = useState(false);
  const [surveyorOptions, setSurveyorOptions] = useState([]);
  const [addSurveyor, setAddSurveyor] = useState(false);
  const [tpaOptions, setTpaOptions] = useState<any[]>([]);
  const [addTpa, setAddTpa] = useState(false);
  const [loader, setLoader] = useState(false);

  const [showSnackBarAlert, setShowSnackBarAlert] = useState({
    status: false,
    type: 'success',
    message: null
  });

  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  const formik = useFormik({
    initialValues: {
      policyClaimId: policyClaimId,
      surveyorId: null,
      tpaId: null,
      status: 'LOR Pending From Surveyor'
    },

    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
      try {
        await request({
          url: policyData?.policyClaimTemplate?.healthClaimCheck
            ? '/policyClaim/allotTpaToPolicyClaimOtp'
            : '/policyClaim/allotSurveyorToPolicyClaimOtp',
          method: 'PUT',
          data: values,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        setShowSnackBarAlert({
          status: true,
          type: 'success',
          message: 'Claim updated'
        });

        // Delay form close to allow snackbar visibility
      } catch (error) {
        setShowSnackBarAlert({
          status: true,
          type: 'error',
          message: 'Failed to update'
        });
      } finally {
        setSubmitting(false);
      }
    }
  });

  useEffect(() => {
    if (policyClaimId) {
      getPolicyData();
    }
  }, [policyClaimId]);
  const getPolicyData = async () => {
    await request({
      url: 'policyClaim/getPolicyClaimById',
      method: 'post',
      data: {
        id: policyClaimId
      }
    }).then(
      (response) => {
        setPolicyData(response);

        setLoading(false);
      },
      (error) => {
        setLoading(false);

        console.log(error);
      }
    );
  };

  const fetchTpaList = async () => {
    try {
      setLoadingClaimTypes(true);
      const res = await request({
        url: '/thirdPartyAdministrator/getThirdPartyAdministratorListOtp',
        method: 'POST',
        data: {
          deleteStatus: false,
          limit: 25,
          offset: 0,
          orderColumn: 'id',
          orderDirection: 'DESC',
          search: null
        }
      });

      setTpaOptions(res['thirdPartyAdministratorData']);
    } catch (err) {
      setShowSnackBarAlert({
        status: true,
        type: 'error',
        message: 'Failed to fetch TPA'
      });
      setTpaOptions([]); // Reset to empty array on error
    } finally {
      setLoadingClaimTypes(false);
    }
  };

  const fetchSurveyorList = async () => {
    try {
      setLoadingClaimTypes(true);
      const response = await request({
        url: '/surveyor/getSurveyorListForPolicyClaimsOtp',
        method: 'POST',
        data: {
          search: null,
          orderColumn: 'id',
          orderDirection: 'DESC'
        }
      });

      const data = response;

      if (Array.isArray(data['surveyorData'])) {
        const formatted = data['surveyorData'].map((s) => ({
          label: `${s.firstName} ${s.lastName}`,
          value: s.id
        }));
        setSurveyorOptions(formatted);
      } else {
        setSurveyorOptions([]); // fallback if data.surveyorData is not an array
      }
    } catch (err) {
      setShowSnackBarAlert({
        status: true,
        type: 'error',
        message: 'Failed to fetch surveyors'
      });
      setSurveyorOptions([]);
    } finally {
      setLoadingClaimTypes(false);
    }
  };

  useEffect(() => {
    if (!policyData?.policyClaimTemplate?.healthClaimCheck) {
      fetchSurveyorList();
    } else {
      fetchTpaList();
    }
  }, [policyData]);

  console.log('policyData', policyData);

  return (
    <Container maxWidth="lg">
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="stretch"
        spacing={3}
      >
        <Grid item xs={12} className="ListContainer">
          <Card>
            <CardHeader
              title={
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'left',
                    width: '100%'
                  }}
                >
                  <Typography variant="h6">Claim</Typography>
                </Box>
              }
              sx={{
                py: 1.5,
                px: 2,
                '& .MuiCardHeader-content': {
                  width: '100%'
                }
              }}
            />

            <CardContent>
              <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      sx={{ width: '100%' }}
                      size="small"
                      name="claimType"
                      value={policyData?.claimType?.title}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} sx={{ mt: 2 }}>
                    <Typography variant="h5" component="div">
                      <u>Policy/Claim Details</u>
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      sx={{ width: '100%' }}
                      size="small"
                      name="claimType"
                      value={policyData?.claimReferenceNumber}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      sx={{ width: '100%' }}
                      size="small"
                      name="claimType"
                      value={moment(policyData?.claimDate).format('DD-MM-YYYY')}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      sx={{ width: '100%' }}
                      size="small"
                      name="claimType"
                      value={policyData?.policyProduct.name}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      sx={{ width: '100%' }}
                      size="small"
                      name="claimType"
                      value={policyData?.policy.policyNumber}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      sx={{ width: '100%' }}
                      size="small"
                      name="claimType"
                      value={policyData?.insuredName}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      sx={{ width: '100%' }}
                      size="small"
                      name="claimType"
                      value={moment(policyData?.policy?.policyStartDate).format(
                        'DD-MM-YYYY'
                      )}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      sx={{ width: '100%' }}
                      size="small"
                      name="claimType"
                      value={moment(policyData?.policy?.policyEndDate).format(
                        'DD-MM-YYYY'
                      )}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      sx={{ width: '100%' }}
                      size="small"
                      name="claimType"
                      value={policyData?.claimSubType}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      sx={{ width: '100%' }}
                      size="small"
                      name="claimType"
                      value={policyData?.branch?.branchName}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Grid item xs={12}>
                      <Typography variant="h5" component="div">
                        <u>Surveyor/TPA Details</u>
                      </Typography>
                    </Grid>
                    <br />
                    {!policyData?.policyClaimTemplate?.healthClaimCheck ? (
                      <Grid item xs={12}>
                        <TextField
                          size="small"
                          select
                          label="Select Surveyor"
                          value={formik.values.surveyorId || ''}
                          onChange={(e) =>
                            formik.setFieldValue('surveyorId', e.target.value)
                          }
                          fullWidth
                        >
                          {surveyorOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}

                          {/* Divider */}
                          <MenuItem disabled>────────────</MenuItem>

                          {/* Add New Option Button */}
                          <MenuItem
                            value="add_new"
                            onClick={() => {
                              setAddSurveyor(true);
                            }}
                          >
                            ➕ Add New
                          </MenuItem>
                        </TextField>
                      </Grid>
                    ) : (
                      <Grid item xs={12}>
                        <TextField
                          size="small"
                          select
                          label="Select TPA"
                          value={formik.values.tpaId || ''}
                          onChange={(e: any) =>
                            formik.setFieldValue('tpaId', e.target.value)
                          }
                          fullWidth
                        >
                          {Array.isArray(tpaOptions) &&
                          tpaOptions.length > 0 ? (
                            tpaOptions.map((option) => (
                              <MenuItem key={option.id} value={option.id}>
                                {option.name || `TPA ${option.id}`}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem disabled>No TPAs available</MenuItem>
                          )}

                          <MenuItem disabled>────────────</MenuItem>
                          <MenuItem
                            value="add_new"
                            onClick={() => setAddTpa(true)}
                          >
                            ➕ Add New
                          </MenuItem>
                        </TextField>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  spacing={3}
                  mt={2}
                >
                  <LoadingButton
                    sx={{ mt: { xs: 2, md: 0 } }}
                    loading={loader}
                    variant="contained"
                    type="submit"
                  >
                    Save
                  </LoadingButton>
                </Grid>
              </form>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}

export default PolicyClaimSurveyorEdit;
